import { render, staticRenderFns } from "./topDetails.vue?vue&type=template&id=f71bad42&scoped=true&"
import script from "./topDetails.vue?vue&type=script&lang=js&"
export * from "./topDetails.vue?vue&type=script&lang=js&"
import style0 from "./topDetails.vue?vue&type=style&index=0&id=f71bad42&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f71bad42",
  null
  
)

export default component.exports